import axios from '../api/axios';

const CACHE_KEY = 'nasa_apod_cache_v3';
const CACHE_MAX_AGE_MS = 24 * 60 * 60 * 1000;

let inflightRequest = null;

const toYoutubeEmbed = (url = '') => {
  if (url.includes('/embed/')) return url;
  const match = url.match(/(?:[?&]v=|youtu\.be\/)([\w-]+)/);
  if (match) return `https://www.youtube.com/embed/${match[1]}`;
  return url;
};

const readCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.payload || Date.now() - parsed.savedAt > CACHE_MAX_AGE_MS) return null;
    return parsed.payload;
  } catch {
    return null;
  }
};

const writeCache = (payload) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ savedAt: Date.now(), payload }));
  } catch {
    // ignore
  }
};

export const getCachedApod = () => {
  const payload = readCache();
  return payload ? normalizeApod(payload) : null;
};

export const normalizeApod = (data = {}) => {
  const mediaType = (data.media_type || 'image').toLowerCase();
  const url = data.url || '';
  const hdurl = data.hdurl || '';
  const thumbnail = data.thumbnail_url || '';

  let embedUrl = '';
  let displayUrl = url || hdurl || thumbnail;

  if (mediaType === 'video') {
    if (/youtube\.com|youtu\.be/i.test(url)) {
      embedUrl = toYoutubeEmbed(url);
      displayUrl = thumbnail || displayUrl;
    } else if (url) {
      displayUrl = url;
    } else {
      displayUrl = thumbnail;
    }
  }

  return {
    title: data.title || '',
    explanation: data.explanation || '',
    mediaType,
    url: displayUrl,
    embedUrl,
    isVideo: mediaType === 'video' || Boolean(embedUrl),
  };
};

const fetchApodPayload = async () => {
  const apiBase = (axios.defaults.baseURL || 'http://localhost:3500/').replace(/\/$/, '');

  try {
    const response = await fetch(`${apiBase}/nasa/apod`);
    if (!response.ok) {
      throw new Error(`NASA APOD returned ${response.status}`);
    }
    const data = await response.json();
    if (data.error) {
      throw new Error(data.error);
    }
    const payload = Array.isArray(data) ? data[0] : data;
    if (!payload) {
      throw new Error('NASA APOD returned an empty response');
    }
    writeCache(payload);
    return payload;
  } catch (err) {
    const cached = readCache();
    if (cached) return cached;
    throw err;
  }
};

export const fetchNasaApod = async () => {
  if (!inflightRequest) {
    inflightRequest = fetchApodPayload()
      .then(normalizeApod)
      .finally(() => { inflightRequest = null; });
  }
  return inflightRequest;
};